import { useState } from 'react'
import ReportList from '../components/ReportList'
import ReportEditor from '../components/ReportEditor'

/**
 * AnalyticsStudio.jsx
 *
 * Comprehensive Analytics Studio (Phase 7B + full redesign, Stages
 * 1-10): a Construction Cost Analytical Workspace built entirely on the
 * existing Query Engine / 4 Adapters + Composite Outputs / Visual Engine
 * / Interaction State / Persistence layer — zero second analytical
 * engine. Same route ('analytics-studio'), same navigation entry —
 * App.jsx requires no changes.
 *
 * List/Editor toggle follows the same pattern already used elsewhere in
 * this codebase (e.g. IPC.jsx's selectedIpc state): null = show the
 * list, a value = show the Editor for that report (or a new one).
 */
export default function AnalyticsStudio({ projectId }) {
  const [selectedReportId, setSelectedReportId] = useState(null)
  const [isCreatingNew, setIsCreatingNew] = useState(false)

  function backToList() {
    setSelectedReportId(null)
    setIsCreatingNew(false)
  }

  if (isCreatingNew || selectedReportId) {
    return (
      <ReportEditor
        projectId={projectId}
        reportId={selectedReportId}
        onBack={backToList}
        onSaved={backToList}
      />
    )
  }

  return (
    <ReportList
      projectId={projectId}
      onSelectReport={setSelectedReportId}
      onCreateNew={() => setIsCreatingNew(true)}
    />
  )
}
